export default __webpack_public_path__ + "static/icon-filter-ed0d85a611ad95d8c7d8d67c9758dc6d.svg";